import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

// Staff-only free-form notes textarea on the WO form. Bound to the
// dedicated `internal_notes` field (NOT to `description`, which used
// to carry legacy text from equipment-derived WOs).
//
// Always editable regardless of WO status — PM/crew need to add
// updates after the WO is approved or completed. Never rendered on
// any customer-facing PDF or Web Review.
//
// Extracted from WorkOrderTab.jsx (Feb 2026, iter178).
export function WOInternalNotes({ form, setForm }) {
  return (
    <div className="border-t pt-3" data-testid="internal-notes-section">
      <Label className="text-xs">Internal Notes</Label>
      <Textarea
        value={form.internal_notes || ""}
        onChange={(e) => setForm({ ...form, internal_notes: e.target.value })}
        className="text-sm min-h-[60px]"
        data-testid="input-wo-internal-notes"
      />
    </div>
  );
}
